import { Checkbox, Icon, Tooltip } from "@shopify/polaris";
import { AlertMinor } from "@shopify/polaris-icons";
import { FieldRenderProps } from "react-final-form";
import { FC } from "react";
import styles from "./TagsCheckbox.module.css";

interface SelectedProductsFieldProps extends FieldRenderProps<any> {
}

const TagsCheckbox: FC<SelectedProductsFieldProps> = ({ input, label, isTooltip }) => {

  return (
    <Checkbox
      label={
        <div className={styles["label-wrapper"]}>
          <span>{label}</span>
          {
            isTooltip &&
            <Tooltip
              content={"Anytime a product is \"Made visible\", this tag will also be automatically removed."}
              padding={"4"}
              preferredPosition={"above"}
            >
              <Icon
                source={AlertMinor}
                color="base"
              />
            </Tooltip>
          }
        </div>
      }
      checked={input.value}
      onChange={input.onChange}
    />
  );
};

export default TagsCheckbox;